import { logEvent } from "firebase/analytics";
import { analytics } from "../firebase";
interface SetAnalytics {
  eventName: string;
  params?: undefined | object;
}
export function setAnalyticsData({
  eventName,
  params = undefined,
}: SetAnalytics) {
  console.log(eventName, params);
  if (params) {
    logEvent(analytics, eventName, { ...params });
  } else {
    logEvent(analytics, eventName);
  }
}
